import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'

import { getApps } from '../../redux/ducks/storeDuck';

import Container from '../../components/Container';
import Table from '../../components/Table';
import Button from '../../components/LinkButton';

const columns = [
  { name: 'App', selector: 'name' },
  { name: 'SO', selector: 'so' }
];

function Apps({
  apps, getApps, ...rest
}) {
  const history = useHistory();

  useEffect(() => {
    if (!apps[0]) getApps();
  }, [apps.length]);

  return (
    <Container className="dashboard-container" bgColor="light">
      <div className="dashboard-buttons-container">
        <Button flat textColor="white" onClick={() => history.push('/store/admin/apps/agregar')}>
          Agregar App ✚
        </Button>
      </div>
      <Table
        columns={columns}
        data={apps || []}
        title="Aplicaciones PagaTodo"
      />
    </Container>
  );
}

function mapStateToProps({ store }) {
  return {
    apps: store.apps,
  };
}

export default connect(
  mapStateToProps, {
    getApps,
  }
)(Apps);
